module.exports = __webpack_public_path__ + "img/carousel-1.0d191524.png";